// src/data/vocabulary/sets/m3/index.js

import abilities from './abilities.json';
import opinionadjective from './opinionadjective.json';
import shapeadjective from './shapeadjective.json';
import materialadjective from './materialadjectives.json';
import hobbies from './hobbies.json';
import clothes from './clothes.json';
import clothes2 from './clothes2.json';
import likesAndDislikes from './likes and dislikes.json';
import sports from './sports.json';
import jobs from './jobs.json';
import dailyRoutines from './dailyRoutine.json'; 
import transports from './transports.json';
import watersports from './watersports.json';

export const VOCABULARY_M3_U1 = [
  abilities,
  opinionadjective,
  shapeadjective,
  materialadjective,
  hobbies,
  clothes,
  clothes2,
  likesAndDislikes,
  sports,
  jobs,
  dailyRoutines,
  transports,
  watersports,
];
